import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import ImageWithFallback from 'components/ImageWithFallback';
import { HOMEPAGE_BUCKET_LINK } from 'utils/image/bucketLinks';
import styles from './AdvertisedOnSection.module.css';

export const AdvertisedOnSection = () => {
  return (
    <AboutUsModule background={'tealGradient'}>
      <AboutUsSiteContainer>
        <div className={styles.container}>
          <p
            className={`aboutUsTypographyHeaderMedium ${styles.advertisedOnText}`}
          >
            As advertised on
          </p>

          <div className={styles.advertisedOnLogos}>
            <ImageWithFallback
              src={{
                src: `${HOMEPAGE_BUCKET_LINK}/itv-logo.webp`,
                width: 100,
                height: 50,
              }}
              alt="ITV"
              className={styles.advertisedOnLogo}
            />
            <ImageWithFallback
              src={{
                src: `${HOMEPAGE_BUCKET_LINK}/channel-4-logo.png`,
                width: 36,
                height: 50,
              }}
              alt="Channel 4"
              className={styles.advertisedOnLogo}
            />
            <ImageWithFallback
              src={{
                src: `${HOMEPAGE_BUCKET_LINK}/mtv-logo.webp`,
                width: 76,
                height: 50,
              }}
              alt="MTV"
              className={styles.advertisedOnLogo}
            />
            <ImageWithFallback
              src={{
                src: `${HOMEPAGE_BUCKET_LINK}/guardian-logo.webp`,
                width: 150,
                height: 50,
              }}
              alt="The Guardian"
              className={styles.advertisedOnLogo}
            />
            <ImageWithFallback
              src={{
                src: `${HOMEPAGE_BUCKET_LINK}/sky-logo.webp`,
                width: 82,
                height: 50,
              }}
              alt="Sky"
              className={styles.advertisedOnLogo}
            />
          </div>
        </div>
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
};
